export const MODULE_QUERY_KEY = "absences";

export const AbsenceQueryKeys = {
  // Employee
  employee: (employeeId: string) => [MODULE_QUERY_KEY, "employee", employeeId],

  // Absence requests
  absenceRequests: (params = {}) => [
    MODULE_QUERY_KEY,
    "absence-requests",
    params,
  ],

  // Absence types
  absenceTypesAll: () => [MODULE_QUERY_KEY, "absence-types"] as const,
  absenceTypesList: (companyId: string) => [
    MODULE_QUERY_KEY,
    "absence-types",
    "list",
    { companyId },
  ],
  absenceTypeDetails: (absenceTypeId: string | undefined) => [
    MODULE_QUERY_KEY,
    "absence-types",
    "details",
    { absenceTypeId },
  ],
  mainAbsenceType: (companyId: string) => [
    MODULE_QUERY_KEY,
    "main-absence-type",
    { companyId },
  ],
  absenceTypeHistory: (absenceTypeId: string) => [
    MODULE_QUERY_KEY,
    "absence-type-history",
    absenceTypeId,
  ],
  absenceTypeBalanceHistory: (params: {
    employeeId: string;
    absenceTypeId: string;
    page: number;
    size: number;
  }) => [MODULE_QUERY_KEY, "absence-type-balance-history", params],

  // Absence groups
  absenceGroupsOrderConfiguration: (companyId: string) => [
    MODULE_QUERY_KEY,
    "absence-groups-order-configuration",
    { companyId },
  ],
  absenceGroups: (companyId: string) => [
    MODULE_QUERY_KEY,
    "absence-groups",
    { companyId },
  ],
  absenceGroup: (groupId: string) => [
    MODULE_QUERY_KEY,
    "absence-group",
    { groupId },
  ],

  // Absence requests (employee & managed)
  employeeAbsenceRequestsAll: () =>
    [MODULE_QUERY_KEY, "employee-absence-requests"] as const,
  employeeAbsenceRequests: (params: object) => [
    MODULE_QUERY_KEY,
    "employee-absence-requests",
    params,
  ],
  managedAbsenceRequestsAll: () =>
    [MODULE_QUERY_KEY, "managed-absence-requests"] as const,
  managedAbsenceRequests: (params: object) => [
    MODULE_QUERY_KEY,
    "managed-absence-requests",
    params,
  ],
  employeeAbsenceRequestAll: () =>
    [MODULE_QUERY_KEY, "employee-absence-request"] as const,
  employeeAbsenceRequest: (absenceRequestId: string) => [
    MODULE_QUERY_KEY,
    "employee-absence-request",
    { absenceRequestId },
  ],
  absenceRequestHistory: (absenceRequestId: string) => [
    MODULE_QUERY_KEY,
    "absence-request-history",
    { absenceRequestId },
  ],

  // Calendars
  calendars: (companyId: string) => [MODULE_QUERY_KEY, "calendars", companyId],
  calendar: (calendarId: string) => [
    MODULE_QUERY_KEY,
    "calendar",
    { calendarId },
  ],
  employeeCalendars: (
    companyId: string,
    employeeId: string,
    years: string[]
  ) => [MODULE_QUERY_KEY, "employee-calendars", companyId, employeeId, years],

  // Employee records & balances
  employeeRecordsAll: () => [MODULE_QUERY_KEY, "employee-records"] as const,
  employeesRecords: (params: object) => [
    MODULE_QUERY_KEY,
    "employees-records",
    params,
  ],
  employeeRecords: (params: {
    companyId: string;
    employeeId: string;
    years?: string[];
  }) => [MODULE_QUERY_KEY, "employee-records", params],
  employeePatterns: (employeeId: string) => [
    MODULE_QUERY_KEY,
    "patterns",
    { employeeId },
  ],
  employeeAssignments: (employeeId: string) => [
    MODULE_QUERY_KEY,
    "assignments",
    { employeeId },
  ],
  employeeBalances: (
    employeeId: string | undefined,
    absenceTypeId?: string
  ) => [MODULE_QUERY_KEY, "employee-balances", { employeeId, absenceTypeId }],
  absenceTypeBalances: (
    employeeId: string,
    absenceTypeId: string | undefined,
    billingCycles: string[]
  ) => [
    MODULE_QUERY_KEY,
    "absence-type-balances",
    { employeeId, absenceTypeId },
    billingCycles,
  ],
  employeeAbsences: (params: {
    employeeId: string;
    from: string;
    to: string;
    statuses: string[];
  }) => [MODULE_QUERY_KEY, "employee-absences", params],
  absences: (params: {
    employeeId: string | undefined;
    from?: string;
    to?: string;
    statuses: string[];
  }) => [MODULE_QUERY_KEY, "absences", params],
  employeeGroups: (companyId: string) => [
    MODULE_QUERY_KEY,
    "employee-groups",
    { companyId },
  ],
  organizationUnits: (companyId: string) => [
    MODULE_QUERY_KEY,
    "organization-units",
    { companyId },
  ],
  employeeAbsencePlan: (employeeId: string, year: string) => [
    MODULE_QUERY_KEY,
    "employee-absence-plan",
    { employeeId, year },
  ],
  absencePlans: (params: { employeeId: string; year: string }) => [
    MODULE_QUERY_KEY,
    "absence-plans",
    params,
  ],

  // Feature configuration
  absenceConfiguration: (companyId: string) => [
    MODULE_QUERY_KEY,
    "absence-configuration",
    { companyId },
  ],

  // Export / Import status
  publicHolidays: (from: string, to: string) => [
    MODULE_QUERY_KEY,
    "public-holidays",
    { from, to },
  ],

  exportStatus: (exportId: string | undefined) => [
    MODULE_QUERY_KEY,
    "exportStatus",
    exportId,
  ],
  importStatus: (importId: string | undefined) => [
    MODULE_QUERY_KEY,
    "importStatus",
    importId,
  ],
};
